import { default as CreditorGroupHome } from "./Home";

export default { CreditorGroupHome };